<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text-A"><a href="#/Book1/cover">When Gravity Fails</a></p>
<p class="toc-text"><a href="#/Book1/section2">Epigraphs</a></p>
<p class="toc-text"><a href="#/Book1/section4">Chapter 1</a></p>
<p class="toc-text"><a href="#/Book1/section5">Chapter 2</a></p>
<p class="toc-text"><a href="#/Book1/section6">Chapter 3</a></p>
<p class="toc-text"><a href="#/Book1/section7">Chapter 4</a></p>
<p class="toc-text"><a href="#/Book1/section8">Chapter 5</a></p>
<p class="toc-text"><a href="#/Book1/section9">Chapter 6</a></p>
<p class="toc-text"><span href="#/Book1/section10" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc-text"><span href="#/Book1/section11" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-text"><span href="#/Book1/section12" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc-text"><span href="#/Book1/section13" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc-text"><span href="#/Book1/section14" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc-text"><span href="#/Book1/section15" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc-text"><span href="#/Book1/section16" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc-text"><span href="#/Book1/section17" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc-text"><span href="#/Book1/section18" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc-text"><span href="#/Book1/section19" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc-text"><span href="#/Book1/section20" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc-text"><span href="#/Book1/section21" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc-text"><span href="#/Book1/section22" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc-text"><span href="#/Book1/section23" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc-text-A1"><span href="#/Book2/cover" title="Link target outside of Sample">A Fire in the Sun</span></p>
<p class="toc-text"><span href="#/Book2/section3" title="Link target outside of Sample">Epigraph</span></p>
<p class="toc-text"><span href="#/Book2/section4" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc-text"><span href="#/Book2/section5" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc-text"><span href="#/Book2/section6" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc-text"><span href="#/Book2/section7" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-text"><span href="#/Book2/section8" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc-text"><span href="#/Book2/section9" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-text"><span href="#/Book2/section10" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc-text"><span href="#/Book2/section11" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-text"><span href="#/Book2/section12" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc-text"><span href="#/Book2/section13" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc-text"><span href="#/Book2/section14" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc-text"><span href="#/Book2/section15" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc-text"><span href="#/Book2/section16" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc-text"><span href="#/Book2/section17" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc-text"><span href="#/Book2/section18" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc-text"><span href="#/Book2/section19" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc-text"><span href="#/Book2/section20" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc-text"><span href="#/Book2/section21" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc-text"><span href="#/Book2/section22" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc-text"><span href="#/Book2/section23" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc-text-A1"><span href="#/Book3/cover" title="Link target outside of Sample">The Exile Kiss</span></p>
<p class="toc-text"><span href="#/Book3/section3" title="Link target outside of Sample">Epigraphs</span></p>
<p class="toc-text"><span href="#/Book3/section4" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc-text"><span href="#/Book3/section5" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc-text"><span href="#/Book3/section6" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc-text"><span href="#/Book3/section7" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc-text"><span href="#/Book3/section8" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc-text"><span href="#/Book3/section9" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc-text"><span href="#/Book3/section10" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc-text"><span href="#/Book3/section11" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc-text"><span href="#/Book3/section12" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc-text"><span href="#/Book3/section13" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc-text"><span href="#/Book3/section14" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc-text"><span href="#/Book3/section15" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc-text"><span href="#/Book3/section16" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc-text"><span href="#/Book3/section17" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc-text"><span href="#/Book3/section18" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc-text"><span href="#/Book3/section19" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc-text"><span href="#/about_the_author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?e7c5cef6